import { type ChangeEvent, type FC, useCallback, useState } from 'react'

import { useUnit } from 'effector-react'

import { Button } from '@/components/ui/button.tsx'
import { Dialog } from '@/components/ui/dialog.tsx'
import { TextField } from '@/components/ui/text-field.tsx'
import type { DialogProps } from '@/dialogs/types'
import {
  $selectedCategory,
  renameVaultCategoryFx,
} from '@/models/vault/categories.ts'

interface Props extends DialogProps {}

export const VaultRenameCategoryDialog: FC<Props> = ({ isOpen, onClose }) => {
  const selectedCategory = useUnit($selectedCategory)!
  const isRenameCategoryLoading = useUnit(renameVaultCategoryFx.pending)

  const [name, setName] = useState(selectedCategory.name ?? '')

  const handleSave = useCallback(async () => {
    if (name) {
      await renameVaultCategoryFx({
        categoryId: selectedCategory.id,
        name,
      })

      onClose()
    }
  }, [name, onClose, selectedCategory])

  const handleNameChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => setName(event.target.value),
    [],
  )

  return (
    <Dialog show={isOpen}>
      <Dialog.Header>
        <Dialog.Title>Rename Category</Dialog.Title>
      </Dialog.Header>

      <div className="mt-5">
        <TextField
          autoFocus
          value={name}
          onChange={handleNameChange}
        />
      </div>

      <Dialog.Footer className="grid grid-cols-2 gap-2">
        <Button
          disabled={isRenameCategoryLoading}
          variant="outline"
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          onClick={handleSave}
          isLoading={isRenameCategoryLoading}
          disabled={!name || name === selectedCategory?.name}
        >
          Save
        </Button>
      </Dialog.Footer>
    </Dialog>
  )
}
